import MY_ACCOUNT_LIGHT_ICON from '../../../../../images/logo-my-med-light.svg';
import MY_ACCOUNT_DARK_ICON from '../../../../../images/logo-my-med-dark.svg';
import QUESTION_MARK_LIGHT_ICON from '../../../../../images/ic-help-light.svg';
import QUESTION_MARK_DARK_ICON from '../../../../../images/ic-help-dark.svg';
import ALLWAYS from '../../../../../images/logo-allways.svg';

const getIcon = (icon, backgroundType) => {
  if (!icon) {
    return;
  }

  const icons = {
    MYACCOUNT: {
      light: MY_ACCOUNT_LIGHT_ICON,
      dark: MY_ACCOUNT_DARK_ICON,
    },
    QUESTION_MARK: {
      light: QUESTION_MARK_LIGHT_ICON,
      dark: QUESTION_MARK_DARK_ICON,
    },
    ALLWAYS: ALLWAYS,
  };

  const selectedIcon = icons[icon];

  return selectedIcon[backgroundType] || selectedIcon;
};

export default getIcon;
